// pragma: allowlist secret
import { useEffect } from 'react'

import { ActionIcon, Badge, Loader, Tooltip } from '@mantine/core'

import { useQuery } from '@redwoodjs/web'

import { useTaskModalContext } from 'src/context/TaskModalContext'
import { GET_TASKS } from 'src/graphql/tasks.graphql'
import { TaskStatus } from 'src/graphql/types/tasks'
import IconAdd from 'src/icons/IconAdd'
import IconInfoCircle from 'src/icons/IconInfoCircle'

import SimplifiedTaskRow from './SimplifiedTaskRow'

const TaskList = ({ selectedRecruiters }) => {
  const { handleOpen, registerRefetch } = useTaskModalContext()

  const recruiters = selectedRecruiters.map((recruiter) => recruiter.value)
  const {
    data,
    loading,
    refetch: refetchTasks,
  } = useQuery(GET_TASKS, {
    variables: {
      pageInfo: {
        limit: 100,
        offset: 0,
      },
      filters: {
        status: [TaskStatus.IN_PROGRESS, TaskStatus.NOT_STARTED],
        assigneeIds: recruiters || [],
      },
    },
  })

  const tasks = data?.tasks?.items || []
  const totalCount = data?.tasks?.totalCount ?? 0

  // Register handleRefetch with the context
  useEffect(() => {
    const handleRefetch = () => {
      refetchTasks()
    }
    registerRefetch(handleRefetch)
  }, [registerRefetch, refetchTasks])

  return (
    <div className="flex h-[200px] min-w-0 flex-1 flex-col overflow-hidden rounded border border-doubleNickel-gray-200 p-3 shadow-sm">
      <div className="mb-2 flex flex-row items-center justify-between text-base font-medium text-doubleNickel-gray-800">
        <div className="flex flex-row items-center gap-1.5">
          Tasks
          <Badge size="xs" color="gray" variant="light">
            {totalCount}
          </Badge>
          <Tooltip
            label="Tasks are sorted by nearest due date. Tasks without due dates appear first."
            withArrow
            position="top"
          >
            <div className="flex items-center">
              <IconInfoCircle className="h-3.5 w-3.5 fill-none stroke-doubleNickel-gray-500" />
            </div>
          </Tooltip>
        </div>
        <ActionIcon variant="subtle" color="gray" onClick={() => handleOpen()}>
          <IconAdd className="h-4 w-4 fill-none stroke-doubleNickel-gray-800" />
        </ActionIcon>
      </div>
      <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-auto">
        {tasks.length === 0 && !loading && (
          <div className="flex h-full items-center justify-center text-sm text-doubleNickel-gray-500">
            No tasks
          </div>
        )}
        {loading ? (
          <Loader
            className="flex h-full w-full items-center justify-center"
            size="xs"
            color="gray"
          />
        ) : (
          tasks.map((task) => (
            <SimplifiedTaskRow key={task.taskId} task={task} />
          ))
        )}
      </div>
    </div>
  )
}

export default TaskList
